import { addSource, removeSource } from './sources/source_helpers';
import { addLayer, removeLayer } from './layers/layer_helpers';
import { alltrailsGlpyhs } from './style_helpers';

const createRasterSource = (url, config) => {
  return {
    type: 'raster',
    tiles: [url],
    ...config
  };
};

const createRasterLayer = (id, sourceId, config) => {
  return {
    id,
    type: 'raster',
    source: sourceId,
    ...config
  };
};

const createRasterStyle = (id, url, config) => {
  return {
    version: 8,
    sources: {
      [id]: createRasterSource(url, config)
    },
    layers: [createRasterLayer(id, id, config)],
    glyphs: alltrailsGlpyhs
  };
};

const addRasterOverlay = (map, id, url, sourceConfig, layerConfig) => {
  addSource(map, id, createRasterSource(url, sourceConfig));
  addLayer(map, createRasterLayer(id, id, layerConfig));
};

const removeRasterOverlay = (map, id) => {
  removeLayer(map, id);
  removeSource(map, id);
};

export { createRasterSource, createRasterLayer, createRasterStyle, addRasterOverlay, removeRasterOverlay };
